var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"banner1",attrs:{"data-grx-placement":"","data-grx-step":_vm.step,"data-grx-display-type":_vm.displayType}})])}
var staticRenderFns = []

export { render, staticRenderFns }